<template>
  <q-dialog :model-value="true" persistent :no-route-dismiss="false">
    <q-card :style="{ minWidth }">
      <q-card-section class="text-h6 q-pb-none">
        <slot name="title" />
      </q-card-section>

      <q-card-section :style="{ maxHeight, minHeight }" class="scroll">
        <slot name="content" />
      </q-card-section>

      <q-card-actions>
        <div class="full-width">
          <q-separator spaced="md" />
        </div>
        <div class="row items-center full-width q-gutter-sm">
          <slot name="actions" />
          <q-space />
          <app-button v-if="showCancel" :disable="cancelDisabled" outline :label="cancelLabel || $t('_RSFAP_SHARED_CANCEL')" @click="$emit('cancel')" />
          <app-button v-if="showOk" :disable="okDisabled" :loading="okLoading" :label="okLabel || $t('_RSFAP_SHARED_OK')" @click="$emit('ok')" />
        </div>
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script setup>
defineProps({
  showCancel: { type: Boolean, default: true },
  showOk: { type: Boolean, default: true },
  okDisabled: { type: Boolean, default: false },
  cancelDisabled: { type: Boolean, default: false },
  okLoading: { type: Boolean, default: false },
  minWidth: { type: String, default: "400px" },
  maxHeight: { type: String, default: "55vh" },
  minHeight: { type: String, default: "200px" },
  okLabel: String,
  cancelLabel: String
})
</script>
